import React, { useState } from "react";
import RoundedButton from "../../components/Buttons/RoundedButton/RoundedButton";
import axios from "axios";
import { backend } from "../../backend";
import { useForm } from "react-hook-form";
import "./contactUs.css";
import SEOTags from "../../utils/SEOTags";
import { useAutoExpand } from "../../customHooks/useAutoExpand";
import Layout from "../../components/layout/Layout";
import { validateOptionalPhoneNumber } from "../../utils/validators";

const BreadcrumbListSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: { "@id": "https://www.vakansa.se/", name: "Hem" },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@id": `https://www.vakansa.se/kontakta-oss`,
        name: "Kontakta oss",
      },
    },
  ],
};

function ContactU() {
  const [buttonClicked, setButtonClicked] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const autoExpand = useAutoExpand();

  const onSubmit = async (formData) => {
    try {
      await handleFormSubmit(formData);
      setButtonClicked(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    try {
      await axios.post(
        backend("/api/contact/general-feedback"),

        formData,
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <SEOTags
        title={"Kontakta oss på Vakansa om du har frågor eller feedback!"}
        description={
          "Har du frågor, feedback eller andra inspel till oss på Vakansa? Hör av dig! Vi är relativt ung startup som växer & uppskattar er hjälp!"
        }
        canonicalUrl={"/kontakta-oss"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={BreadcrumbListSchema}
      />
      <Layout>
        <main className="contact-form-section">
          <form
            aria-labelledby="contact-form-heading"
            onSubmit={handleSubmit(onSubmit)}
          >
            <h1 id="contact-form-heading">Kontakta oss</h1>
            <h2>Skriv gärna till oss på Vakansa</h2>
            <p className="contact-form-subheading">
              Har du frågor, feedback eller andra inspel till oss på Vakansa?
              Hör då av dig! Vi är relativt ung startup som växer & vill göra
              det bra!
            </p>
            <div className="contact-form-name">
              <label htmlFor="name">Ditt namn*</label>
              <input
                id="name"
                {...register("name", { required: true })}
                aria-invalid={errors.name ? "true" : "false"}
                aria-describedby={errors.name ? "name-error" : undefined}
              />

              {errors.name && (
                <span id="name-error" role="alert">
                  Vänligen ange ett namn
                </span>
              )}
            </div>
            <div className="contact-form-email-number">
              <div>
                <label htmlFor="email">E-postadress*</label>
                <input
                  id="email"
                  type="email"
                  {...register("email", { required: true })}
                  aria-invalid={errors.email ? "true" : "false"}
                  aria-describedby={errors.email ? "email-error" : undefined}
                />
                {errors.email && (
                  <span id="email-error" role="alert">
                    Vänligen ange en giltig e-postadress
                  </span>
                )}
              </div>
              <div className="contact-form-phone">
                <label htmlFor="phone-number">Telefon</label>
                <input
                  id="phone-number"
                  {...register("phone", {
                    validate: validateOptionalPhoneNumber,
                  })}
                  aria-invalid={errors.phone ? "true" : "false"}
                  aria-describedby={errors.phone ? "phone-error" : undefined}
                />
                {errors.phone && (
                  <span id="phone-error" role="alert">
                    {errors.phone.message}
                  </span>
                )}
              </div>
            </div>

            <div className="contact-form-message">
              <label htmlFor="text-area">Meddelande*</label>
              <textarea
                id="text-area"
                placeholder="Skriv ditt meddelande här"
                {...register("message", { required: true })}
                onInput={autoExpand}
                aria-invalid={errors.message ? "true" : "false"}
                aria-describedby={errors.message ? "message-error" : undefined}
              />
              {errors.message && (
                <span id="message-error" role="alert">
                  Meddelandet kan inte vara tomt
                </span>
              )}
            </div>
            <br />
            <p>Fält markerade med * är obligatoriska</p>
            <br />
            <div className="contact-form-checkbox">
              <input
                type="checkbox"
                id="terms"
                {...register("checkbox", { required: true })}
                aria-invalid={errors.checkbox ? "true" : "false"}
                aria-describedby={errors.checkbox ? "terms-error" : undefined}
              />
              <label for="terms">
                Jag bekräftar att jag har läst och godkänner{" "}
                <a
                  href="/anvandarvillkor"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  användarvillkoren
                </a>
                , inklusive att avtalsvite kan utgå vid bristande återkoppling
                eller kringgående av plattformen.*
              </label>
              <br />
              {errors.checkbox && (
                <span id="terms-error" role="alert">
                  Du måste acceptera villkoren
                </span>
              )}
            </div>
            <div className="contact-form-send-button-container">
              {buttonClicked ? (
                <p>Tack för ditt meddelande!</p>
              ) : (
                <RoundedButton
                  className="contact-form-send-button"
                  color="green"
                  label="Skicka"
                  size="md"
                />
              )}
            </div>
          </form>
        </main>
      </Layout>
    </>
  );
}

export default ContactU;
